import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {CountriesListService} from '../../services/countries-list.service';
import {DomainType, NameServerVO, TopLevelDomainVO, TrustAnchorVO} from '../../generate/TopLevelDomainVO';
import {CommonStrings} from '../../model/CommonStrings';
import {Definitions} from '../../model/Definitions';
import {RequestMetadata} from '../../generate/RequestMetadata';
import {OrganizationVO} from '../../generate/OrganizationVO';
import {ContactVO} from '../../generate/ContactVO';


@Component({
  selector: 'common-new-delegation',
  templateUrl: './common-new-delegation.component.html',
  styleUrls: ['./common-new-delegation.component.scss']
})
export class CommonNewDelegationComponent implements OnInit {

  topLevelDomain: TopLevelDomainVO;

  requestMetadata: RequestMetadata;

  currentLoc: number;

  revealedLoc: number;

  isCreatingDomain: boolean;


  constructor(private router: Router, private location: Location, private countriesListService: CountriesListService) {
  }

  ngOnInit() {
    this.currentLoc = 0;
    this.revealedLoc = 0;
    this.getInputData(history.state);
  }

  getInputData(data: any) {
    if (data) {
      this.topLevelDomain = data.domain;
      this.requestMetadata = data.requestMetadata;
      this.isCreatingDomain = data.isCreatingDomain;
      if (this.isCreatingDomain) {
        this.topLevelDomain.status = 'Inactive';
      }
      this.countriesListService.load();
    } else {
      this.cancel(true);
    }
  }

  goTo(currentLoc: number) {
    this.currentLoc = currentLoc;
  }

  cancel(val: boolean) {
    if (this.currentLoc === 0) {
      this.location.back();
    } else {
      this.currentLoc--;
    }
  }


  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  getTabName(): string {
    return this.getTabNameBasedOnGivenLocation(this.currentLoc);
  }

  getTabNameBasedOnGivenLocation(location: number): string {
    switch (location) {
      case 0:
        return CommonStrings.TYPE_OF_TLD;
      case 1:
        return this.getSponsoringOrgTabNameBasedOnType();
      case 2:
        return CommonStrings.ADMINISTRATIVE_CONTACT;
      case 3:
        return CommonStrings.TECHNICAL_CONTACT;
      case 4:
        return CommonStrings.NAME_SERVERS;
      case 5:
        return CommonStrings.TRUST_ANCHORS;
      case 6:
        return CommonStrings.ADDITIONAL_INFORMATION;

    }
  }


  getSponsoringOrgTabNameBasedOnType(): string {
    if (this.topLevelDomain.type === 'GENERIC') {
      return CommonStrings.REGISTRY_OPERATOR;
    } else {
      return CommonStrings.CC_TLD_MANAGER;
    }
  }

  getTabDescription(): string {
    switch (this.currentLoc) {
      case 0:
        return Definitions.NEW_DELEGATION_TLD_TYPE_DESCRIPTION;
      case 1:
        return this.getSponsoringOrgTabDescriptionBasedOnType();
      case 2:
        return Definitions.NEW_DELEGATION_AC_DESCRIPTION;
      case 3:
        return Definitions.NEW_DELEGATION_TC_DESCRIPTION;
      case 4:
        return Definitions.NEW_DELEGATION_NAMESERVERS_DESCRIPTION;
      case 5:
        if (this.topLevelDomain.type === 'GENERIC') {
          return Definitions.NEW_DELEGATION_TRUSTANCHORS_DESCRIPTION_GTLD;
        } else {
          return Definitions.NEW_DELEGATION_TRUSTANCHORS_DESCRIPTION;
        }

      case 6:
        return Definitions.NEW_DELEGATION_ADDITIONALINFO_DESCRIPTION;

    }
  }

  getSponsoringOrgTabDescriptionBasedOnType() {
    if (this.topLevelDomain.type === 'GENERIC') {
      return Definitions.NEW_DELEGATION_RO_DESCRIPTION;
    } else {
      return Definitions.NEW_DELEGATION_CCTLD_MANAGER_DESCRIPTION;
    }
  }

  domainTypeOutput(domainType: DomainType) {
    this.topLevelDomain.type = domainType;
    this.currentLoc = 1;
    this.setRevealedLoc(1);
  }

  sponsoringOrgOutput(organizationVO: OrganizationVO) {
    this.topLevelDomain.organization = organizationVO;
    this.currentLoc = 2;
    this.setRevealedLoc(2);
  }

  contactACOutPut(contactVO: ContactVO) {
    this.topLevelDomain.administrative = contactVO;
    this.currentLoc = 3;
    this.setRevealedLoc(3);
  }

  contactTCOutPut(contactVO: ContactVO) {
    this.topLevelDomain.technical = contactVO;
    this.currentLoc = 4;
    this.setRevealedLoc(4);
  }

  nameServerOutPut(nameServers: Array<NameServerVO>) {
    this.topLevelDomain.nameServers = nameServers;
    this.currentLoc = 5;
    this.setRevealedLoc(5);
  }

  trustAnchorsOutput(trustAnchors: Array<TrustAnchorVO>) {
    this.topLevelDomain.trustAnchors = trustAnchors;
    this.currentLoc = 6;
    this.setRevealedLoc(6);
  }

  domainOutPut(domain: TopLevelDomainVO) {
    this.topLevelDomain = domain;
    this.currentLoc = 7;
    this.setRevealedLoc(7);
  }

  setRevealedLoc(number: number) {
    if (number > this.revealedLoc) {
      this.revealedLoc = number;
    }
  }

  getDomainType(): string {
    if (this.topLevelDomain.type) {
      return this.topLevelDomain.type.toString().replace('_', ' ');
    }
  }

}
